import { render, staticRenderFns } from "./commission-details-container.vue?vue&type=template&id=54d5ca0c"
import script from "./commission-details-container.vue?vue&type=script&lang=ts"
export * from "./commission-details-container.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports